import * as e from "react";
import t from "../lib/SSRBase.es.js";
import m from "../defs/Gear.es.js";
const r = e.forwardRef((o, a) => /* @__PURE__ */ e.createElement(t, { ref: a, ...o, weights: m }));
r.displayName = "GearIcon";
const f = r;
export {
  f as Gear,
  r as GearIcon
};
